import { Camera2D } from "./Scene2DSpecial/Camera2D";
import { Sprite } from "./Sprite";
import { Point } from "../maths/Point";
import { RenderState2D } from "../webgl/utils/RenderState2D";
import { NodeFlags } from "../Const";
export class Area2D extends Sprite {
    constructor() {
        super();
        this._setBit(NodeFlags.AREA_2D, true);
    }
    get mainCamera() {
        return this._mainCamera;
    }
    _setMainCamera(camera) {
        if (camera == this._mainCamera)
            return;
        this._mainCamera && (this._mainCamera._isMain = false);
        this._mainCamera = camera;
        if (this._mainCamera) {
            this._mainCamera._isMain = true;
        }
    }
    _preRenderUpdate(context) {
        let shaderData = this._scene.sceneShaderData;
        if (this._mainCamera) {
            context.drawLeftData();
            if (shaderData) {
                shaderData.addDefine(Camera2D.SHADERDEFINE_CAMERA2D);
                shaderData.setMatrix3x3(Camera2D.VIEW2D, this._mainCamera._getCameraTransform());
            }
        }
    }
    render(ctx, x, y) {
        this._preRenderUpdate(ctx);
        this._scene._curCamera = this.mainCamera;
        super.render(ctx, x, y);
        if (this._mainCamera) {
            let shaderData = this._scene.sceneShaderData;
            ctx.drawLeftData();
            if (shaderData) {
                shaderData.removeDefine(Camera2D.SHADERDEFINE_CAMERA2D);
            }
        }
        this._scene._curCamera = null;
    }
    _setBelongScene(scene) {
        super._setBelongScene(scene);
        this._scene._area2Ds.push(this);
    }
    _setUnBelongScene() {
        let areaArray = this._scene._area2Ds;
        let index = areaArray.indexOf(this);
        if (index != -1) {
            areaArray.splice(index, 1);
        }
        super._setUnBelongScene();
    }
    transformPoint(x, y, out) {
        out = out || new Point();
        out.setTo(x, y);
        if (!this._mainCamera)
            return out;
        this.localToGlobal(out);
        this.mainCamera.localToGlobal(out);
        out.x -= RenderState2D.width * 0.5;
        out.y -= RenderState2D.height * 0.5;
        this.globalToLocal(out);
        return out;
    }
}
